export type AnalyticsBuilderTemplateStructureItem = {
  id?: string;
  displayName: string;
  urlSegement: string;
};

export type AnalyticsBuilderFieldOption = {
  id: string;
  key: string;
  name: string;
  options?: AnalyticsBuilderFieldOption[];
  disabled?: boolean;
};

export enum AnalyticsBuilderFieldTypeType {
  Hidden = 'Hidden',
  TaxonomyDropdown = 'TaxonomyDropdown',
  SearchText = 'SearchText',
  Dropdown = 'Dropdown',
  AutocompleteCity = 'Autocomplete (City)',
  AutocompleteGeography = 'Autocomplete (Geography)',
  AutocompleteCompany = 'Autocomplete (Company)',
}

export type AnalyticsBuilderFieldType = {
  displayName?: string;
  options?: AnalyticsBuilderFieldOption[];
  queryParameterName: string;
  type: AnalyticsBuilderFieldTypeType;
  disablefirstLevelOptionSelect?: boolean;
};

export type AnalyticsBuilderFieldSetType = {
  fields: AnalyticsBuilderFieldType[];
  name: string;
};

export type AnalyticsBuilderTemplateType = {
  displayName: string;
  description: string;
  inputDescription?: string;
  areas: AnalyticsBuilderTemplateStructureItem[];
  urlSegement: string;
  fieldSetNames?: string[];
};

export type AnalyticsBuilderResolvedTemplateStructureItem = AnalyticsBuilderTemplateStructureItem & {
  id: string;
};

export type AnalyticsBuilderResolvedTemplateType = Omit<AnalyticsBuilderTemplateType, 'areas' | 'id'> & {
  id: string;
  areas: AnalyticsBuilderResolvedTemplateStructureItem[];
  fieldSet: AnalyticsBuilderFieldSetType;
};

export type AnalyticsBuilderInputs = {
  [key: string]: string | undefined;
};

export type AnalyticsBuilderReportData = {
  id: string;
  displayName: string;
  subject: string;
  title: string;
  description: string;
  sections: AnalyticsBuilderReportSectionData[];
};

export type AnalyticsBuilderReportSectionStatus = 'loading' | 'done' | 'failed';

export type AnalyticsBuilderReportSectionData = {
  id: string;
  title: string;
  html?: string;
  sources?: AnalyticsBuilderDataResponseSourceModel[];
  status?: AnalyticsBuilderReportSectionStatus;
};

export type AnalyticsBuilderDataRequestModel = {
  urlSegment: string[];
  queryParams: Record<string, any>;
};

export enum AnalyticsBuilderAutocompleteTaxonomy {
  City = 'city',
  Industry = 'industry',
  Geograph = 'geograph',
  Company = 'company',
}

export type AnalyticsBuilderAutocompleteOption = {
  label: string;
  value: string;
};

export type AnalyticsBuilderDataResponseSourceModel = {
  chunkText: string;
  publishedDate: string;
  recordType: string;
  sourceId: string;
  title: string;
};

export type AnalyticsBuilderDataSuccessResponseModel = {
  data: {
    response: string;
    sources: AnalyticsBuilderDataResponseSourceModel[];
  };
  status: 'Success';
};

export type AnalyticsBuilderDataFailedResponseModel = {
  status: 'Failed';
  errormessage?: string;
};

export type AnalyticsBuilderDataResponseModel =
  | AnalyticsBuilderDataSuccessResponseModel
  | AnalyticsBuilderDataFailedResponseModel;
